<div class="me-landing-page-proof">
    <div tabindex="0" class="container">
        <div class="row">
            <div class="col-xs-12">
                <div class="me-landing-page-proof__icon">
                    <img src="{{data.icon.filename}}">
                </div>
            </div>
            <div class="col-xs-12">
                <div class="me-landing-page-proof__header" [innerHTML]="data.headline | storyblokRichtext"></div>
            </div>
            <div class="col-xs-12">
                <div class="me-landing-page-proof__description" [innerHTML]="data.paragraph | storyblokRichtext"></div>
            </div>
            <div class="col-xs-12">
                <div class="me-landing-page-proof__body">
                    <div class="me-landing-page-proof__grid">
                        <div *ngFor="let proof of data.proofs" class="me-landing-page-proof__grid-content">
                            <div class="grid-content__icon">
                                <img src="{{proof.icon.filename}}">
                            </div>
                            <div class="grid-content__text" [innerHTML]="proof.text | storyblokRichtext"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
